import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=230d270e&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=230d270e&lang=less&scoped=true&"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=230d270e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d270e",
  null
  
)

export default component.exports